import axios from '../axios'
import Qs from "qs"
/* 
 * 系统登录模块
 */

// 登录
export const login = data => {
    return axios({
        url: 'login',
        method: 'post',
        data,
        transformRequest: [function (data) {
            data = Qs.stringify(data);
            return data;
        }],
        headers: {
            tenantId: localStorage.getItem('tenantId'),
            loginType: 2,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

// 登出
export const logout = () => {
    return axios({
        url: 'logout',
        method: 'get',
        headers: {
            tenantId: localStorage.getItem('tenantId')
        },
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/login.js